import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LoginLayoutComponent } from '@app/root/components/login-layout/login-layout.component';
import { AuthApiService } from '@services/auth-api.service';
import Utils from '@shared/providers/utils';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-pass-forgot',
  imports: [FormsModule, SharedModule, LoginLayoutComponent],
  templateUrl: './pass-forgot.component.html',
})
export class PassForgotComponent {
  readonly authApiService = inject(AuthApiService);
  readonly destroyRef = inject(DestroyRef);
  readonly route = inject(ActivatedRoute);

  success = signal(false);
  isSending = signal(false);
  error = signal(this.route.snapshot.queryParamMap.get('error') ?? '');
  username = signal(this.route.snapshot.queryParamMap.get('name') ?? '');

  onSend() {
    this.success.set(false);
    this.error.set('');
    this.isSending.set(true);
    this.authApiService
      .forgotPassword(this.username())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.success.set(true);
          this.isSending.set(false);
        },
        error: (err: HttpErrorResponse) => {
          this.error.set(Utils.formatHttpError(err));
          this.isSending.set(false);
        },
      });
  }
}
